module.exports = __webpack_public_path__ + "img/draw.6fdeb53b.png";